module.exports = __webpack_public_path__ + "img/menu.2b279b9c.svg";